<template>
  <div>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 class="font-medium text-uppercase mb-0">Presentations Managers <span class="badge badge-primary">{{count}}</span></h5>
        </div>
        <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
          <nav aria-label="breadcrumb" class="mt-2 float-md-right float-left">
            <ol class="breadcrumb mb-0 justify-content-end p-0">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Presentations Managers</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="page-content container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="form-group col-4">
                <div class="input-group">
                  <span class="input-group-btn">
                    <button type="button" class="btn waves-effect waves-light btn-info">
                      <i class="fa fa-search"></i>
                    </button>
                  </span>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search by presenter email, presentationID, access code"
                    @change="searchPresentation()"
                    v-model="textSearch"
                  />
                </div>
              </div>
              <div class="table-responsive">
                <div class="text-center">
                  <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
                </div>
                <div class="form-group">
                  <div class="col-md-12">Sort By</div>
                  <div class="col-md-3">
                    <select class="form-control" @change="changeSort()" v-model="sortBy">
                      <option value="createdBy">Creation date</option>
                      <option value="updatedBy">Last updating date</option>
                    </select>
                  </div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Created by</th>
                      <th>Title</th>
                      <th>Access code</th>
                      <th @click="sortByCreatedAt()">
                        Created at
                        <i
                          class="fas fa-sort"
                          aria-hidden="true"
                          v-if="sortBy == 'createdBy'"
                        ></i>
                      </th>
                      <th @click="sortByUpdatedAt()">
                        Last updated
                        <i
                          class="fas fa-sort"
                          aria-hidden="true"
                          v-if="sortBy == 'updatedBy'"
                        ></i>
                      </th>
                     
                      <th>IP address</th>
                      <th>Share Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :key="index" v-for="(item, index) in items" class="pointer">
                      <td>{{item.id}}</td>
                      <td>
                        <div>
                          <a :href="'mailto:' + item.User.email"></a>
                          {{item.User.email}}
                        </div>
                        <div>{{item.User.firstName}} {{item.User.lastName}}</div>
                      </td>
                      <td>{{item.name}}</td>
                      <td>{{item.accessCode}}</td>
                      <td>{{item.createdAt | dateTime}}</td>
                      <td>{{item.updatedAt | dateTime}}</td>
                     
                      <td>{{item.ipAddress}}</td>
                      <td>
                        <a v-if="item.shareCode" :href="'https://presenter.ahaslides.com/share/' + item.shareCode +'?presenting=true'" target="_blank">Click show presentation</a>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="overflow-auto">
                  <b-pagination v-model="page" :total-rows="count" per-page="20"></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Config from "@/config";
export default {
  name: "Presentations",
  data() {
    return {
      items: [],
      page: 1,
      count: 0,
      isLoading: false,
      sortAsc: false,
      sortVote: false,
      sortReaction: false,
      sortUpdatedAt: false,
      sortBy: "createdBy",
      textSearch: ""
    };
  },
  created() {
    this.getData();
  },
  mounted() {},
  watch: {
    page: {
      handler: function() {
        this.getData();
      },
      deep: true
    }
  },
  methods: {
    searchPresentation () {
      this.getData();
    },
    changeSort() {
      this.getData();
    },
    sortByUpdatedAt() {
      this.sortUpdatedAt = !this.sortUpdatedAt;
      this.getData();
    },
   
    sortByCreatedAt() {
      this.sortAsc = !this.sortAsc;

      this.getData();
    },
    getData() {
      let params = {
        sortBy: this.sortBy,
        page: this.page
      };
      if (this.textSearch) {
        params.textSearch = this.textSearch
      }

      if (this.sortBy == "createdBy") {
        params.value = this.sortAsc;
      } else if (this.sortBy == "updatedBy") {
        params.value = this.sortUpdatedAt;
      } else if (this.sortBy == "vote") {
        params.value = this.sortVote;
      } else if (this.sortBy == "reaction") {
        params.value = this.sortReaction;
      }
      this.isLoading = true;
      this.$http
        .get(Config.api.sortPresentation, {
          params: params
        })
        .then(res => {
          this.isLoading = false;
          this.items = res.body.result;
          this.count = res.body.count;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.addUser-btn {
  background-color: #4f9af2;
  border-radius: 20px;
  border-color: #4f9af2;
  &:hover {
    background-color: #2785f0;
    border-color: #2785f0;
  }
}
</style>
